module.exports = __webpack_public_path__ + "static/media/team-3.2d391370.jpg";